const { useState, useEffect } = require("react");

export const useDebouncedValue = (value, delay=300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, 500);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
